import { Badge, Button, Flex, HStack, IconButton, SimpleGrid, Stack, Stat, StatNumber, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { Link as DefaultLink } from 'react-router-dom';
import { EmptyTable } from 'components/index';
import { FiRefreshCw } from 'react-icons/fi';
import { TbTrolley } from 'react-icons/tb';
import { fetchParcelDeliveries } from '../../store/actions';
import { parcelDeliveryType } from '../../types';

export const ViewParcels = () => {

    const [isRefreshing, setRefreshing] = useState<boolean>(false);
    const { parcel_deliveries } = useAppSelector(state => state.parcelDeliveryReducer);

    const dispatch = useAppDispatch();

    const filterParcelDeliveryByStatus = (status: string) => {
        const parcels = parcel_deliveries?.filter((parcel_delivery: parcelDeliveryType) => parcel_delivery.status === status);
        return parcels;
    };

    const handleRefreshParcelDeliveries = async () => {
        setRefreshing(true);
        await dispatch(fetchParcelDeliveries())
            .finally(() => setRefreshing(false));
    };

    useEffect(() => {
        dispatch(fetchParcelDeliveries());
    }, []);

    return (
        <Flex
            minH={'-webkit-fill-available'}
            align={'center'}
            justify={'center'}
            pt={2}
            pb={10}
        >
            <Stack spacing={4}>
                <SimpleGrid columns={[1, 1, 3, 3, 3]} spacing={4}>
                    <HStack bg={'#FFFFFF'} p={4} borderRadius={6} minW={'300px'}>
                        <Stack p={6} bg='#f5f5f5' borderRadius={'50%'} mr={2}>
                            <TbTrolley style={{ width: '40px', height: '40px' }} />
                        </Stack>
                        <Stat>
                            <Badge minW={'80px'} colorScheme={'green'} px={2} borderRadius={3}>Delivered Parcels</Badge>
                            <StatNumber>{filterParcelDeliveryByStatus('delivered')?.length}</StatNumber>
                        </Stat>
                    </HStack>
                    <HStack bg={'#FFFFFF'} p={4} borderRadius={6} minW={'300px'}>
                        <Stack p={6} bg='#f5f5f5' borderRadius={'50%'} mr={2}>
                            <TbTrolley style={{ width: '40px', height: '40px' }} />
                        </Stack>
                        <Stat>
                            <Badge minW={'80px'} colorScheme={'gray'} px={2} borderRadius={3}>Received Parcels</Badge>
                            <StatNumber>{filterParcelDeliveryByStatus('received')?.length}</StatNumber>
                        </Stat>
                    </HStack>
                    <HStack bg={'#FFFFFF'} p={4} borderRadius={6} minW={'300px'}>
                        <Stack p={6} bg='#f5f5f5' borderRadius={'50%'} mr={2}>
                            <TbTrolley style={{ width: '40px', height: '40px' }} />
                        </Stack>
                        <Stat>
                            <Badge minW={'80px'} colorScheme={'orange'} px={2} borderRadius={3}>Arrived Parcels</Badge>
                            <StatNumber>{filterParcelDeliveryByStatus('arrived')?.length}</StatNumber>
                        </Stat>
                    </HStack>
                </SimpleGrid>
                <Stack bgColor={'white'} p={4} borderRadius={6}>
                    <HStack justifyContent={'space-between'} mb={4} px={2}>
                        <Text textTransform={'capitalize'} fontSize={20} fontWeight={'medium'}>Parcel Deliveries</Text>
                        <HStack>
                            <IconButton
                                icon={<FiRefreshCw />}
                                size={'sm'}
                                aria-label={'Refresh icon button'}
                                onClick={handleRefreshParcelDeliveries}
                                isLoading={isRefreshing}
                                isDisabled={isRefreshing}
                            />
                            <Button colorScheme={'yellow'} size='sm' as={DefaultLink} to='/parcels/add'>
                                Add Parcel Delivery
                            </Button>
                            <Button colorScheme={'yellow'} variant={'outline'} size='sm' as={DefaultLink} to='/pickup-points/add'>
                                Add Pickup Point
                            </Button>
                        </HStack>
                    </HStack>
                    <SimpleGrid>
                        <TableContainer>
                            <Table variant='simple'>
                                <Thead>
                                    <Tr>
                                        <Th>Parcel ID</Th>
                                        <Th>First name</Th>
                                        <Th>last name</Th>
                                        <Th>ID Number</Th>
                                        <Th>email</Th>
                                        <Th>phone</Th>
                                        {/* <Th>is customer location</Th> */}
                                        <Th>pickup</Th>
                                        <Th>dropoff</Th>
                                        {/* <Th>address</Th> */}
                                        <Th>status</Th>
                                        <Th>amount</Th>
                                        <Th>payment status</Th>
                                        <Th></Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        parcel_deliveries?.map((parcel: parcelDeliveryType, index: number) => (
                                            <Tr key={index}>
                                                <Td fontWeight={'medium'}>{parcel?.parcel_id}</Td>
                                                <Td textTransform={'capitalize'}>{parcel?.first_name}</Td>
                                                <Td textTransform={'capitalize'}>{parcel?.last_name}</Td>
                                                <Td textTransform={'capitalize'}>{parcel?.id_number ? parcel?.id_number : '-'}</Td>
                                                <Td>{parcel?.email}</Td>
                                                <Td textTransform={'capitalize'}>{parcel?.phone}</Td>
                                                {/* <Td textTransform={'capitalize'}>{parcel?.is_customer_location ? true : false}</Td> */}
                                                <Td textTransform={'capitalize'}>{parcel?.pickup_address}</Td>
                                                <Td textTransform={'capitalize'}>{parcel?.dropoff_address}</Td>
                                                {/* <Td textTransform={'capitalize'}>{parcel?.address ? parcel?.address : '-'}</Td> */}
                                                <Td textTransform={'capitalize'}>
                                                    <Badge colorScheme={parcel?.status === 'received' ? 'gray' : parcel?.status === 'arrived' ? 'yellow' : parcel?.status === 'delivered' ? 'green' : parcel?.status === 'dispatched' ? 'orange' : 'red'}>{parcel?.status}</Badge>
                                                </Td>
                                                <Td textTransform={'capitalize'} color={'green.500'} fontWeight={'bold'}>R{parcel?.amount.toFixed(2)}</Td>
                                                <Td textTransform={'capitalize'} color={'green.500'} fontWeight={'bold'}>
                                                    <Badge colorScheme={parcel?.payment_status === 'paid' ? 'green' : 'gray'}>{parcel?.payment_status}</Badge>
                                                </Td>
                                                <Td>
                                                    <HStack>
                                                        <Button colorScheme={'teal'} size={'xs'} as={DefaultLink} to={'/parcels/edit'} state={{ parcel }}>Edit</Button>
                                                    </HStack>
                                                </Td>
                                            </Tr>
                                        ))
                                    }
                                </Tbody>
                            </Table>
                            {!parcel_deliveries.length && <EmptyTable title='Oops!' description='Your company does not have parcel deliveries.' />}
                        </TableContainer>
                    </SimpleGrid>
                </Stack>
            </Stack>
        </Flex>
    );
};